import { render, staticRenderFns } from "./ChangeAccessModal.vue?vue&type=template&id=4533a6a8"
import script from "./ChangeAccessModal.vue?vue&type=script&lang=js"
export * from "./ChangeAccessModal.vue?vue&type=script&lang=js"
import style0 from "./ChangeAccessModal.vue?vue&type=style&index=0&id=4533a6a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports